import UserService from "app/Service/ClientUser/UserService"
import CancelButton from "app/WebView/Component/Buttons/CancelButton"
import CreateButton from "app/WebView/Component/Buttons/CreateButton"
import DeleteButton from "app/WebView/Component/Buttons/DeleteButton"
import RequireButton from "app/WebView/Component/Buttons/RequireButton"
import SaveButton from "app/WebView/Component/Buttons/SaveButton"
import BackIcon from "app/WebView/Component/icons/backIcon"
import {ButtonProps, IToolbarButton} from "app/WebView/Toolbar/ToolbarView.model"
import cls from "classnames"
import React from "react"
import {Button, Dropdown} from "react-bootstrap"
import {useNavigate} from "react-router-dom"

function ToolbarButton({button}: ButtonProps) {
  const navigate = useNavigate()
  if (button.type) {

    const {hasRole} = UserService([], 'ToolbarButton')

    let disabled: boolean = button.disabled ?? false
    if (button.role) {
      if (!hasRole(button.role))
        disabled = true
    }

    switch (button.type) {
      case "dropdownHref":
        return <ToolbarButtonDropdown button={button}/>
      case "back":
        return <BackIcon id={`back`} onClick={() => navigate(-1)} variant={'secondary'} className={`back-${button.id}`}/>
    }

    if (undefined === button.onClick) {
      throw Error(`Provide onclick method for button: ${button.type}-${button.id}`)
    }

    switch (button.type) {
      case 'save':
        return <SaveButton id={button.id} onClick={button.onClick} disabled={disabled} title={button.title} variant={button.variant}/>
      case "cancel":
        return <CancelButton id={button.id} onClick={button.onClick} disabled={disabled}/>
      case "create":
        if (undefined === button.title)
          throw Error(`Provide a title for button: ${button.type}-${button.id}`)
        return <CreateButton id={button.id} onClick={button.onClick} title={button.title} disabled={disabled}/>
      case "delete":
        if (undefined === button.title)
          throw Error(`Provide a title for button: ${button.type}-${button.id}`)
        return <DeleteButton id={button.id} onClick={button.onClick} title={button.title} disabled={disabled}/>
      case "require":
        if (undefined === button.title)
          throw Error(`Provide a title for button: ${button.type}-${button.id}`)
        return <RequireButton title={button.title} id={button.id} onClick={button.onClick} disabled={disabled}/>
      default:
        return <></>
    }
  } else {
    return (
      <Button
        key={button.id}
        id={button.id}
        onClick={button.newTab ? () => window.open(button.newTab) : button.onClick}
        variant={button.color}
        className={cls({'active': button.active})}
        disabled={button.disabled}
      >
        {button.title}
      </Button>
    )
  }
}

interface ToolbarButtonDropdownProps {
  button: IToolbarButton
}

function ToolbarButtonDropdown({button}: ToolbarButtonDropdownProps) {
  if (undefined === button.dropdownData)
    return null
  return (
    <Dropdown id={`toolbar-${button.id}`}>
      <Dropdown.Toggle className={'sw-icon'} variant={'blank'}>
        {button.displayIcon ? React.createElement(button.displayIcon, {id: button.id, onClick: () => null, wrapper: 'span'}) : button.title}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {button.dropdownData.map(data => {
          return <Dropdown.Item key={data.id} href={`mailto:${data.name}`}>{data.name}</Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ToolbarButton
